import { createCommand, type LexicalCommand } from "lexical";

import type { OfferNodeData } from "./OfferNode";

/** Payload to insert (or replace) the editor's single offer chip. */
export type InsertOfferPayload = OfferNodeData;

export const INSERT_OFFER_COMMAND: LexicalCommand<InsertOfferPayload> =
  createCommand("INSERT_OFFER_COMMAND");

export const REMOVE_OFFER_COMMAND: LexicalCommand<{ slug: string }> =
  createCommand("REMOVE_OFFER_COMMAND");
